import React from "react";
import { SpinnerComponent } from "shared";
import StudentSpecificDataImg from "assets/images/Student-specific-data.png";
import "../styles/studentSpecificData.style.css";

export const StudentSpecificDataList = ({
  studentDataDisplayName,
  studentSpecificData,
  studentSpecificDataQuery,
  onCloseModal,
}) => {
  return (
    <div className="modal_a_c student_details">
      <div className="student_details_image_wrapper">
        <img
          src={StudentSpecificDataImg}
          className="student_details_icon"
          alt="student-specific-data"
        />
      </div>

      <div className="student_details_content_modal mt-2">
        <p className="student_details_title text-center">
          {studentDataDisplayName}
        </p>

        {studentSpecificData ? (
          studentSpecificData.map((element, index) => (
            <div
              key={index}
              className="pt-3 student_details_content_block d-flex flex-column justify-content-between align-items-center"
            >
              <div>
                {Object.entries(element).map(([key, value]) => (
                  <div
                    className="d-flex justify-content-between align-items-center mb-4 gap-3"
                    key={`${key}_${index}`}
                  >
                    <span className="student_details_message">{key}</span>
                    <strong>{value}</strong>
                  </div>
                ))}
              </div>
              {index !== studentSpecificData.length - 1 && <hr />}
              <button
                className="btn btn-nergy-primary btn btn-primary btn-student_details"
                onClick={onCloseModal}
              >
                Ok
              </button>
            </div>
          ))
        ) : studentSpecificDataQuery?.isLoading ? (
          <div className="text-center mt-3">
            <SpinnerComponent />
          </div>
        ) : (
          <span className="student_details_error">No data found!</span>
        )}
      </div>
    </div>
  );
};
